import React, { useMemo, useState } from 'react';
import { Alert, AlertTitle, Button, Checkbox, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import { useQuery } from 'hooks/useQuery';
import {es} from 'date-fns/locale';
import dayjs from 'dayjs';

//services
import { updateOrCreateGuest } from 'services/events';
//components
import { documentGuestTypes, eventsGeneres } from 'pages/PaymentLink/options';
import FormYoungGest from './FormYoungGest';
import ControllerField from 'components/Controllers/ControllerField/ControllerField';
import ControllerAutocomplete from 'components/Controllers/ControllerAutocomplete/ControllerAutocomplete';

const FormGuest = ({ guest, sizes, isYoung, setDataResponse, blood, event }) => {

  const { control, handleSubmit, formState: { errors },  setError, watch, getValues, setValue } = useForm({
    defaultValues: guest
  });

  const [ loading, setLoading ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState();

  const sizes_guest = useMemo(() => {

    return sizes?.filter(option => option.genre === (getValues('genre_form')?.name ?? guest?.genre) )
  },[watch('genre_form'), sizes, guest])

  const sizes_young = useMemo(() => {

    return sizes?.filter(option => option.genre === (getValues('young_genre_form')?.name ?? guest?.young_genre) )
  },[watch('young_genre_form'), sizes, guest])

  const query = useQuery()
  const ticketUuid = query.get('t')

  const onSubmit = (values) => {
    values.id = guest?.id;
    values.ticket = ticketUuid;
    values.document_type = values.document_type_form?.id;
    values.genre = values.genre_form?.id;
    values.size_id = values.size_id_form?.id;
    values.rh = values.rh_form?.id;
    values.birthdate = dayjs(values.birthdate).format("YYYY-MM-DD");

    if (isYoung) {
      values.parent_document_type = values.parent_document_type_form?.id;
      values.young_document_type = values.young_document_type_form?.id;
      values.young_genre = values.young_genre_form?.id;
      values.young_size_id = values.young_size_id_form?.id;
      values.young_birthdate = dayjs(values.young_birthdate).format("YYYY-MM-DD");
    }

    if (values.email?.toLowerCase() != values.email2?.toLowerCase()) {
      setError('email', 'No es igual a email2');
      setError('email2', 'No es igual a email');

      setErrorMessage('Los correos deben ser iguales');
      return;
    }

    setLoading(true);

    updateOrCreateGuest(values)
      .then(({ data }) => {
        setDataResponse(data?.data);
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} >

      <Grid container spacing={2} >

        <Grid item xs={4} md={6}>
          <ControllerAutocomplete
            control={control}
            name={'document_type_form'}
            label={'Tipo de documento'}
            options={documentGuestTypes}
            defaultValue={guest?.document_type ? documentGuestTypes.find(e => e.id == guest?.document_type) : null}
          />
        </Grid>

        <Grid item xs={8} md={6}>
          <ControllerField
            control={control}
            name={'document_number'}
            label={'Numero de documento'}
            allowPaste={false}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ControllerField
            control={control}
            name={'first_name'}
            label={'Nombres'}
            allowPaste={false}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ControllerField
            control={control}
            name={'last_name'}
            label={'Apellidos'}
            allowPaste={false}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            rules={{
              required: true
            }}
            control={control}
            name='birthdate'
            defaultValue={guest?.birthdate}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                <MobileDatePicker
                  disableFuture
                  {...field}
                  renderInput={(props) =>
                    <TextField
                      {...props}
                      error={errors?.birthdate}
                      fullWidth
                    />
                  }
                  label={'Fecha de nacimiento'}
                  placeholder={'Fecha de nacimiento'}
                  openTo="year"
                  inputFormat='dd/MM/yyyy'
                  mask={'__/__/____'}
                  maxDate={dayjs(Date.now()).subtract(16, "years")}
                  minDate={dayjs(Date.now()).subtract(100, "years")}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ControllerAutocomplete
            control={control}
            name={'genre_form'}
            label={'Genero'}
            options={eventsGeneres}
            defaultValue={guest?.genre ? eventsGeneres.find((e) => e.name == guest?.genre) : null}
            onChange={() => {
              setValue('size_id_form', null)
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ControllerField
            control={control}
            name={'email'}
            label={'Correo'}
            allowPaste={false}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ControllerField
            control={control}
            name={'email2'}
            label={'Verifica el correo'}
            allowPaste={false}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ControllerField
            control={control}
            name={'phone'}
            label={'Telefono'}
            allowPaste={false}
            type='number'
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <ControllerField
            control={control}
            name={'eps'}
            label={'EPS'}
            allowPaste={false}
          />
        </Grid>

        <Grid item xs={6}>
          <ControllerAutocomplete
            control={control}
            name={'rh_form'}
            label={'RH'}
            options={blood}
            defaultValue={guest?.rh ? blood.find(e => e.id == guest?.rh) : null}
          />
        </Grid>

        {
          sizes_guest &&
          <Grid item xs={6}>
            <ControllerAutocomplete
              control={control}
              name={'size_id_form'}
              label={'Talla'}
              options={sizes_guest}
              defaultValue={guest?.size_id ? sizes.find(e => e.id == guest?.size_id) : null}
            />
          </Grid>
        }

        {
          !isYoung &&
          <>
            <Grid item xs={12} md={6}>
              <ControllerField
                control={control}
                name={'emergency_person'}
                label={'Persona de emergencia'}
                allowPaste={false}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <ControllerField
                control={control}
                name={'emergency_phone'}
                label={'Telefono de emergencia'}
                allowPaste={false}
              />
            </Grid>
          </>
        }

        {
          isYoung == 1 &&
          <FormYoungGest control={control} errors={errors} guest={guest} sizes={sizes_young} setValue={setValue}/>
        }

        <Grid item xs={12}>
          <Controller
            rules={{
              required: true,
              min: 1
            }}
            control={control}
            name='terms'
            defaultValue={guest?.terms == 1 ? 1 : 0}
            render={({ field }) => (
              <>
                <FormControlLabel
                  label={"Autorizo el tratamiento de mis datos"}
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value}
                    />
                  }
                />

                {
                  errors?.terms &&
                  <Typography fontSize={10} color={'error'} >Requerido</Typography>
                }
              </>
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            rules={{
              required: true,
              min: 1
            }}
            control={control}
            name='exonerations'
            defaultValue={guest?.exonerations == 1 ? 1 : 0}
            render={({ field }) => (
              <>
                <FormControlLabel
                  label={
                    <p>
                        Entiendo que al participar en este evento, libero a los organizadores de
                        cualquier responsabilidad por lesiones o daños durante mi participación. {" "}
                        {
                          event?.url_exonerations &&
                          <a href={event?.url_exonerations} target="_blank" style={{fontSize: 10}}>(EXONERACION)</a>
                        }
                    </p>
                  }
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value}
                    />
                  }
                />

                {
                  errors?.exonerations &&
                  <Typography fontSize={10} color={'error'} >Requerido</Typography>
                }
              </>
            )}
          />
        </Grid>

        {
          errorMessage &&
          <Grid item xs={12} >
            <Alert style={{ marginBottom: 20 }} severity={'warning'}>
              <AlertTitle>Info</AlertTitle>
              {errorMessage}
            </Alert>
          </Grid>
        }

        <Grid item xs={12}>
          <Button
            type='submit'
            variant={"contained"}
            disabled={loading}
          >
            Guardar
          </Button>
        </Grid>
      </Grid>

    </form>
  )

}

export default FormGuest
